import React from "react";
import { twMerge } from "tailwind-merge";
import { CustomerDetails } from "@components/CustomerDetails/CustomerDetails";
import { ArrowNarrowLeftIcon } from "@components/icons";
import { LanguageSelectButton } from "@components/Language/LanguageSelectButton";
import { Link } from "@components/Link/Link";
import { Logo } from "@components/Logo/Logo";
import { TopBarMenuIcon } from "@components/TopBar/components/TopBarMenuIcon";

interface ITopBarProps {
  title?: React.ReactNode;
  actionBar?: React.ReactNode;
  navigateBackLink?: string;
  shouldNavigateBackOnlyOnMobile?: boolean;
  children?: React.ReactNode;
}

export const TopBar: React.FC<ITopBarProps> = (props) => {
  const {
    title,
    actionBar,
    navigateBackLink,
    shouldNavigateBackOnlyOnMobile,
    children,
  } = props;

  return (
    <React.Fragment>
      <div className="sticky inset-0 z-40 flex justify-between border-b border-grey-light bg-background-grey px-4 py-5 md:-mx-8 md:px-8 lg:border-0 lg:py-10">
        <Logo className="cursor-pointer lg:hidden" />
        <div className="hidden items-center lg:inline-flex">
          {navigateBackLink && (
            <Link
              to={navigateBackLink}
              className={twMerge(
                "text-grey-dark hover:text-base-black",
                shouldNavigateBackOnlyOnMobile && "hidden",
              )}
            >
              <ArrowNarrowLeftIcon className="-mt-1.5 mr-3 inline text-black" />
            </Link>
          )}
          <h1 className="p-0 font-bold">{title}</h1>
        </div>
        <div className="hidden gap-4 lg:flex">
          <LanguageSelectButton variant="topbar" />
          <CustomerDetails />
        </div>
        <TopBarMenuIcon />
      </div>
      {(!!actionBar || !!title) && (
        <div
          className={twMerge(
            "sticky inset-0 inset-y-[65px] z-40 mb-[1px] bg-background-grey px-4 py-5 md:-mx-8 md:px-8 md:pb-4 lg:inset-y-[120px] lg:pt-0",
            !actionBar && "lg:hidden",
          )}
        >
          <div className="flex justify-between">
            <div className="inline-flex items-center lg:hidden">
              {navigateBackLink && (
                <Link
                  className="text-grey-dark hover:text-base-black"
                  to={navigateBackLink}
                >
                  <ArrowNarrowLeftIcon className="-mt-1.5 mr-3 inline text-black" />
                </Link>
              )}
              {title && <h1 className="p-0">{title}</h1>}
            </div>
            {actionBar}
          </div>
          {children}
        </div>
      )}
    </React.Fragment>
  );
};
